export const queryKeys = {
  products: ['products'] as const,
  locations: ['locations'] as const,
  quantityUnits: ['quantity-units'] as const,
  quantityUnitConversions: ['quantity-unit-conversions'] as const,
  stock: ['stock'] as const,
  shoppingList: ['shopping-list'] as const,
  productGroups: ['product-groups'] as const,
  productBarcodes: ['product-barcodes'] as const,
  userSettings: ['user-settings'] as const,
  recipes: ['recipes'] as const,
  recipeIngredients: ['recipe-ingredients'] as const,
  aiModelsOpenAI: ['ai-models-openai'] as const,
  aiModelsOpenRouter: ['ai-models-openrouter'] as const,
} as const; 